import React, { Component } from 'react';
import { Grid } from "@material-ui/core";


export default class CustomCennterDivider extends Component {
	render() {
		return (
			<Grid container style={{ alignItems: 'center', justifyContent: 'center' }}>
				<Grid item>
					<div style={{ width: '120px', height: '4px', backgroundColor: '#ff8000', borderRadius: '2px', marginBottom: '22px' }}></div>
				</Grid>
			</Grid>
		);
	}
}
